import { render, staticRenderFns } from "./vConfirm.vue?vue&type=template&id=99f6b330&"
import script from "./vConfirm.vue?vue&type=script&lang=js&"
export * from "./vConfirm.vue?vue&type=script&lang=js&"
import style0 from "./vConfirm.vue?vue&type=style&index=0&id=99f6b330&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports